import './function/initMaps';

import './fontawesome-all.min.js';


// WEBPACK FOOTER //
// ./src/assets/js/index.js